import ajax from './index'
import apiEnv from './apiEnv'
// 角色配置 
// 获取角色列表
export function adminRoleList(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/AdminRole/GetAdminRoleList`, data)
}
// 设置菜单 获取角色tree
export function menuListByRole(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/AdminRole/GetMenuListByRole`, data)
}
// 设置菜单 提交角色tree
export function setRoleMenuList(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/AdminRole/SetRoleMenuList`, data)
}
// 设置功能 获取角色tree
export function actionTreeList(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/RoleAction/GetActionTreeList`, data)
}
// 设置功能 提交角色tree
export function setRoleAction(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/RoleAction/SetRoleAction`, data)
}
// END


// 菜单管理
// 菜单列表
export function getMenuList(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/AdminMenu/GetMenuList`, data)
}
// 添加菜单
export function addAdminMenu(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/AdminMenu/AddAdminMenu`, data)
}
// 编辑菜单
export function updateAdminMenu(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/AdminMenu/UpdateAdminMenu`, data)
}
// 删除菜单
export function deleteAdminMenu(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/AdminMenu/DeleteAdminMenu`, data)
}
// 获取dialog菜单列表select
export function menuListData(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/AdminMenu/GetMenuData`, data)
}
// END


// 功能管理 
// 功能列表
export function managerActionList(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/Action/GetManagerActionList`, data)
}
// 新增或编辑功能设置
export function setAction(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/Action/SetAction`, data)
}
// 删除功能列表
export function deleteAction(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/Action/DeleteAction`, data)
}
// 获取dialog功能菜单select
export function functionListMenu(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/Menu/ListMenu`, data)
}
// END